module.exports = {
  SOCKET_URL: process.env.VUE_APP_SOCKET_URL || 'https://assetanalysis-socketservices-mo7niavhjq-de.a.run.app/v1',
  API_URL: process.env.VUE_APP_API_URL || 'https://brooklyn-dev.techolution.com',
  API_URL_MS: process.env.VUE_API_URL_MS || 'https://brooklyn-dev.techolution.com'
}
